import PropTypes from "prop-types";
import classNames from "classnames";
import { isFunction, noop } from "lodash";
import { t } from "@/i18n-js/instance";
import { Icon } from "@circle-react-shared/Icon";
import { Alert } from "@circle-react-shared/uikit/AlertV2";
import { Dropdown } from "@circle-react-uikit/Dropdown";
import { TranscriptsPlayer } from "@circle-react-uikit/TranscriptsPlayer";

export const MediaWithPlayback = ({
  isAudioMode,
  featuredMedia,
  onRemove = noop,
}) => {
  const { current_storage: currentStorage } = featuredMedia;

  const shouldShowTemporaryTranscodingNotice =
    !isAudioMode && currentStorage === "aws";

  return (
    <div className="space-y-4">
      <div
        className={classNames(
          "flex",
          isAudioMode ? "items-center" : "items-start",
        )}
      >
        <div className="flex-1">
          <TranscriptsPlayer
            key={featuredMedia.id}
            src={featuredMedia?.playback_url}
            downloadUrl={featuredMedia?.url}
            signedId={featuredMedia?.signed_id}
            type={featuredMedia?.content_type}
            mediaTranscriptId={featuredMedia?.media_transcript_id}
            isDownloadable={featuredMedia?.is_downloadable}
            poster={featuredMedia?.thumbnail_image_url}
            preload="auto"
            menuPosition={isAudioMode ? "bottom" : "top"}
          />
        </div>
        <Dropdown
          button={
            <div className="text-dark cursor-pointer">
              <Icon type="menu-dots-v2" size={20} />
            </div>
          }
        >
          <Dropdown.ItemWithLink
            onClick={() => isFunction(onRemove) && onRemove()}
          >
            {t("remove")}
          </Dropdown.ItemWithLink>
        </Dropdown>
      </div>
      {shouldShowTemporaryTranscodingNotice && (
        <Alert
          title={t("courses.edit.lesson.temporary_transcoding_notice.title")}
          description={t(
            "courses.edit.lesson.temporary_transcoding_notice.description",
          )}
        />
      )}
    </div>
  );
};

MediaWithPlayback.propTypes = {
  featuredMedia: PropTypes.object,
  isAudioMode: PropTypes.bool,
  onRemove: PropTypes.func,
};
